/* eslint-disable no-undef */
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueAuth from '@websanova/vue-auth'
import NProgress from 'vue-nprogress'
import { sync } from 'vuex-router-sync'
import App from './App.vue'
import router from './router'
import store from './store'
import * as filters from './filters'
import { TOGGLE_SIDEBAR } from 'vuex-store/mutation-types'
import Popover from 'vue-js-popover'
import VueSocketio from 'vue-socket.io'
import jwt from 'jsonwebtoken'
// import util from 'util'

Vue.use(VueAxios, axios)
Vue.router = router
Vue.use(VueAuth, {
  auth: {
    request: function (req, token) {
      this.options.http._setHeaders.call(this, req, {Authorization: 'Bearer ' + token})
    },
    response: function (res) {
      // Get Token from response body
//      return res.headers.token
      console.log(res.data)
      return res.data.access_token
    }
  },
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  rolesVar: 'role',
  loginData: { fetchUser: false },
  fetchData: { enabled: false },
  refreshData: { enabled: false },
  tokenDefaultName: 'access_token',
  facebookData: {
    url: 'common/auth/oauth2',
    method: 'POST',
    redirect: '/'
  },
  facebookOauth2Data: {
    clientId: '_CLIENT_ID_PLACE_HOLDER_',
    response_type: 'code',
    url: '_AUTHORIZE_API_PLACE_HOLDER_',
    redirect: function () { return this.options.getUrl() },
    scope: 'openid profile'
  },
/*
  parseOauthState: function (data) {
    console.log('parseOauthState: ' + data)
  },
*/
  parseUserData: function (data) {
    console.log('parseUserData: ' + data)
    if (window.localStorage[this.options.tokenDefaultName] !== null) {
      var decodedToken = jwt.decode(window.localStorage[this.options.tokenDefaultName])
      decodedToken.role = 'user'
      Vue.nextTick(() => {
        window.dispatchEvent(new CustomEvent('auth-token-localstorage-changed', {
          detail: {
            token: window.localStorage.getItem(this.options.tokenDefaultName)
          }
        }))
      })
      return decodedToken
    } else {
      return null
    }
/*
    if (window.localStorage[this.options.tokenDefaultName] !== null) {
      var decodedToken = jwt.decode(window.localStorage[this.options.tokenDefaultName])
      if (decodedToken.role === 1) {
        decodedToken.role = 'pm'
      } else if (decodedToken.role === 2) {
        decodedToken.role = 'user'
      } else {
        decodedToken.role = 'unidentified'
      }
      return decodedToken
    } else {
      return null
    }
*/
  }
})

Vue.axios.defaults.baseURL = window.location.protocol + '//' + window.location.hostname + ':' + window.location.port + '/api'

Vue.use(NProgress)
Vue.use(Popover)
Vue.use(VueSocketio, window.location.protocol + '//' + window.location.hostname + ':' + window.location.port)

// Disable devtools
Vue.config.devtools = false

sync(store, router)

const { state } = store

const nprogress = new NProgress({ parent: '.nprogress-container' })

router.beforeEach((route, redirect, next) => {
  if (state.app.device.isMobile && state.app.sidebar.opened) {
    store.commit(TOGGLE_SIDEBAR, false)
  }
  next()
})

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

const app = new Vue({
  router,
  store,
  nprogress,
  ...App
})

export { app, router, store }



// WEBPACK FOOTER //
// ./client/app.js